export const setHoursandMinutesOnDate = (date: Date, hours: string, minutes: string) => {
  const newDate = new Date(date)
  newDate.setHours(parseInt(hours, 10), parseInt(minutes, 10))
  return newDate
}
